import { BtnBack } from "../../../../components/button/button-back";
import { BtnSubmit } from "../../../../components/button/button-submit/button-submit";
import CurrencyInput from "../../../../components/inputs/currency";
import SelectInput from "../../../../components/inputs/select";
import TextInput from "../../../../components/inputs/text";
import Installment from "../../../../components/installment/parameters";
import ShowTableInstallments from "../../../../components/installment/table/table-installments-show";
import Loading from "../../../../components/loading";
import ModalMain from "../../../../components/modal";
import libForm from "../../../../util/libForm";
import { IndexHook } from "./hooks";
import { RegisterClientProvider } from "../../../../components/register/register-cliente/context";
import { MainRegisterClient } from "../../register-cliente";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { useEffect } from "react";

const Form = ({
	isOpenModalRegister,
	ident,
	idTable,
	selectedData,
	setSelectData,
	fetchID,
	reloadData,
	reloadFetchFirstData,
	insert,
}) => {
	//#region useForm
	const {
		//useForm
		register,
		control,
		errors,
		isSubmitting,

		setValue,
		handleSubmit,

		//Data
		categoryData,
		costCenterData,

		//hooks
		handleOnSubmit,
		handleCloseModalRegister,

		//installment
		installments,
		identModalInstallment,
		handleOpenModalinstallment,
		CallBackInstallments,

		//variables
		valorTotal,
		loading,
		isInsert,
	} = IndexHook({
		isOpenModalRegister,
		ident,
		idTable,
		selectedData,
		setSelectData,
		fetchID,
		reloadData,
		reloadFetchFirstData,
		insert,
	});
	//#endregion

	const identModalSelectClient = "modalSelectClient";

	const handleOpenModalSelectClient = (e) => {
		if (e && e.preventDefault) e.preventDefault();
		const event = new CustomEvent(identModalSelectClient);
		window.dispatchEvent(event);
	};

	useEffect(() => {
		const handleKeyDown = (e) => {
			if (e.key === "F2" && isInsert) {
				e.preventDefault();
				handleOpenModalSelectClient(e);
			}
		};
		window.addEventListener("keydown", handleKeyDown);
		return () => window.removeEventListener("keydown", handleKeyDown);
	}, [isInsert]);

	const handleCloseModalSelectClient = () => {
		const event = new CustomEvent(identModalSelectClient);
		window.dispatchEvent(event);
	};

	const onSelectClient = (item) => {
		setValue("id_cliente", item.id_cliente, { shouldValidate: true });
		setValue("nome_cliente", item.nome, { shouldValidate: true });
		handleCloseModalSelectClient();

		setTimeout(() => {
			document.getElementById("valor")?.focus();
		}, 100);
	};

	return (
		<>
			{loading ? (
				<div className="flex h-full">
					<Loading mensagem="Carregando..." />
				</div>
			) : (
				<>
					<form
						className="form"
						onSubmit={handleSubmit(
							handleOnSubmit,
							// handleOnError
						)}
					>
						<main className="overflow-auto">
							{/* se for cadastro mostra a tabela com a parcela atual */}
							{isInsert ? (
								<>
									<div className="row">
										<div className="col-12 d-flex align-items-end pb-3">
											<div className="flex-grow-1">
												<TextInput
													id="nome_cliente"
													label="Cliente Selecionado [Atalho: F2]"
													placeholder="Clique na lupa ou pressione F2..."
													register={register}
													errors={errors}
													disabled={true}
													className="col-12 mb-0"
												/>
											</div>
											<button
												type="button"
												className="btn btn-primary ms-2"
												style={{ height: "38px", marginBottom: "5px" }}
												onClick={handleOpenModalSelectClient}
												autoFocus={true}
												title="Buscar Cliente (F2)"
											>
												<FontAwesomeIcon icon={faSearch} />
											</button>
										</div>

										<CurrencyInput
											label="Valor total da receita"
											name="valor"
											control={control}
											errors={errors}
											placeholder="Digite o valor total da receita"
											required={true}
											decimalScale={2}
											prefix="R$ "
											className={`col-6 col-sm-6 col-lg-2`}
											onKeyDown={libForm.EnterTab}
											truncate={true}
										/>

										<TextInput
											label="Descrição"
											id="descricao"
											placeholder=""
											register={register}
											errors={errors}
											onKeyDown={libForm.EnterTab}
											className="col-12 col-sm-7 col-lg-7"
										/>

										<SelectInput
											label="Categoria"
											id="id_conta_tipo"
											labelSelect="nome"
											control={control}
											errors={errors}
											data={categoryData}
											setValue={setValue}
											onKeyDown={libForm.EnterTab}
											// handleSelect={handleSelectedState}
											// loading={loadingCities}
											className="col-12 col-sm-6 col-lg-4"
										/>

										<TextInput
											label="Observações da receita"
											id="obs"
											placeholder=""
											register={register}
											errors={errors}
											onKeyDown={libForm.EnterTab}
											className="col-12 col-sm-7 col-lg-12"
										/>
									</div>

									{/* Mostra as parcela no formulario principal recebe as parcelas e o control para alterar a tabela */}
									<ShowTableInstallments
										installments={installments}
										control={control}
										setValue={setValue}
									/>

									<div className="flex justify-end me-1">
										<button
											type="button"
											className="btn btn-primary btn-sm ms-1 mt-4"
											onClick={handleOpenModalinstallment}
											onKeyDown={libForm.EnterTab}
										>
											Parcelar
										</button>
									</div>
								</>
							) : (
								<>
									<div className="row">
										<div className="col-12 d-flex align-items-end pb-3">
											<div className="flex-grow-1">
												<TextInput
													id="nome_cliente"
													label="Cliente"
													placeholder="Cliente selecionado na criação"
													register={register}
													errors={errors}
													disabled={true}
													className="col-12 mb-0"
												/>
											</div>
										</div>

										<TextInput
											label="Descrição"
											id="descricao"
											placeholder=""
											register={register}
											errors={errors}
											onKeyDown={libForm.EnterTab}
											className="col-12 col-sm-7 col-lg-7"
										/>

										<SelectInput
											label="Categoria"
											id="id_conta_tipo"
											labelSelect="nome"
											control={control}
											errors={errors}
											data={categoryData}
											setValue={setValue}
											onKeyDown={libForm.EnterTab}
											// handleSelect={handleSelectedState}
											// loading={loadingCities}
											className="col-12 col-sm-6 col-lg-4"
										/>

										<TextInput
											label="Observações da receita"
											id="obs"
											placeholder=""
											register={register}
											errors={errors}
											onKeyDown={libForm.EnterTab}
											className="col-12 col-sm-7 col-lg-12"
										/>

										<div className="border-bottom mt-3 mb-3">Dados da Parcela</div>

										<ShowTableInstallments
											installments={installments}
											control={control}
											setValue={setValue}
										/>
									</div>
								</>
							)}
						</main>

						<div className="flex justify-between flex-row-reverse p-1">
							<BtnSubmit text="Salvar" isSubmitting={isSubmitting} />
							<BtnBack onClick={(e) => handleCloseModalRegister()} isSubmitting={isSubmitting} />
						</div>
					</form>
				</>
			)}

			{/* Modal para selecionar parcelamento e dadas de pagamento passando o valor total e esperando de volta o Data do formulario*/}
			<ModalMain
				ident={identModalInstallment}
				overlayClassName="react-modal-overlay"
				className="react-modal-content-base w-full max-w-[1050px] h-[90%] bg-white p-4 relative m-10"
			>
				<Installment installmentValue={valorTotal} CallBackInstallments={CallBackInstallments} />
			</ModalMain>

			{/* Modal de Seleção de Cliente */}
			<ModalMain
				ident={identModalSelectClient}
				className="react-modal-content-base w-full max-w-[1250px] h-[95%] bg-white p-4 relative m-10"
			>
				<RegisterClientProvider>
					<MainRegisterClient isSelector={true} onSelectClient={onSelectClient} />
				</RegisterClientProvider>
			</ModalMain>
		</>
	);
};

export default Form;
